import { type JSX, Show } from 'solid-js';
import { openAccessBlockers, useBlockers } from '../lib/blockers';
import { QueryBoundary } from './QueryBoundary';
import { RepoAccessPanel } from './RepoAccessPanel';

// Container for the repo view's access panel (epic #3756): the account's OPEN
// blockers (`GET /v1/blockers?open=true`, the Blockers page's own query and
// cache entry), narrowed to this repo's access asks by `openAccessBlockers`.
//
// MOUNTED ONLY WHEN IT HAS SOMETHING TO SAY. Most repos owe nothing, so the
// loading and empty states are silent here rather than a skeleton and an empty
// box above every repo's tabs. What stays loud is a FAILED read — the boundary's
// error or denied arm — because a hidden failure would read as "nothing owed".

export function RepoAccessBlockers(props: {
  readonly fullName: string;
  readonly token: string | null;
}): JSX.Element {
  const query = useBlockers(() => true, props.token);
  const asks = () => openAccessBlockers(query.data ?? [], props.fullName);
  return (
    <Show when={query.isError || asks().length > 0}>
      <QueryBoundary query={query} loading={null}>
        {() => <RepoAccessPanel blockers={asks()} />}
      </QueryBoundary>
    </Show>
  );
}
